import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import styled from "styled-components";
import LazyLoad from "react-lazyload";
import sanityClient from "../../sanityClient";
import mediaTalk from "../../assets/images/who-we-are/newsroom.webp";
import videoLink from "../../assets/images/newsroom/habitatbuffalovideosample.webp";
import picturesLink from "../../assets/images/newsroom/pictureslink.webp";

const AllTheGoodStuff = () => {
  const [mediaItems, setMediaItems] = useState([]);
  const [error, setError] = useState(null); // State for error handling

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "media"] | order(publishedAt desc) {
          _id,
          title,
          description,
          publishedAt,
          "fileUrl": file.asset->url,
          "imageUrl": image.asset->url
        }`
      )
      .then((data) => setMediaItems(data))
      .catch((error) => {
        console.error(error);
        setError("Failed to load media items. Please try again later.");
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>All The Good Stuff - Habitat for Humanity Buffalo</title>
        <meta
          name="description"
          content="Explore Habitat for Humanity Buffalo's media resources, including press kits, media libraries, and important documents. Stay updated with our latest news and projects."
        />
      </Helmet>
      <Container role="main">
        {error && <ErrorMessage>{error}</ErrorMessage>}{" "}
        {/* Display error message */}
        <Section>
          <h1>Habitat Buffalo Press Kit</h1>
          <Text>
            Thank you for your interest in Habitat for Humanity Buffalo. Our
            experts are available to the media on a wide array of topics,
            including affordable housing, residential home construction and
            repairs, neighborhood revitalization, community development,
            volunteerism, philanthropy and nonprofit fundraising, disaster
            recovery, and recycling with the Habitat Buffalo ReStore.
          </Text>
          <Image
            src={mediaTalk}
            alt="Electronic Press Kit for Habitat Buffalo"
          />
        </Section>
        <Section>
          <h2 className="section-header primary">Media Library</h2>
          <MediaLibrary>
            <MediaCard>
              <LazyLoad height={200} offset={100}>
                <MediaImage
                  src={picturesLink}
                  alt="Photos from Habitat Buffalo"
                />
              </LazyLoad>
              <MediaButton
                href="https://www.flickr.com/photos/habitatbuffalo/"
                target="_blank"
                rel="noopener noreferrer"
              >
                CLICK HERE FOR PHOTOS
              </MediaButton>
            </MediaCard>
            <MediaCard>
              <LazyLoad height={200} offset={100}>
                <MediaImage src={videoLink} alt="Videos from Habitat Buffalo" />
              </LazyLoad>
              <MediaButton
                href="https://www.youtube.com/@habitatbuffalo606"
                target="_blank"
                rel="noopener noreferrer"
              >
                CLICK HERE FOR VIDEOS
              </MediaButton>
            </MediaCard>
          </MediaLibrary>
        </Section>
        <Section>
          <h2 className="section-header orange">Documents</h2>
          <DocumentList>
            {[
              "Our Story",
              "Faith",
              "Habitat Buffalo ReStores General Donations",
              "Habitat Buffalo ReStores Corporate Donations",
              "Homeownership",
              "Service Area",
              "Veterans Initiative",
              "Volunteer",
              "Youth Programs",
            ].map((doc, index) => (
              <DocumentItem key={index}>
                <a href="#">{doc}</a>
              </DocumentItem>
            ))}
          </DocumentList>
        </Section>
      </Container>
    </>
  );
};

const ErrorMessage = styled.div`
  color: red;
  text-align: center;
  padding: 20px;
  font-size: 1.5em;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
`;

const Section = styled.section`
  margin-bottom: 60px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const Text = styled.p``;

const Image = styled.img`
  width: 100%;
  height: auto;
  border-radius: 8px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

const MediaLibrary = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 20px;
`;

const MediaCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 400px;
`;

const MediaImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 20px;
`;

const MediaButton = styled.a`
  display: inline-block;
  background-color: var(--primary-color);
  color: var(--secondary-color);
  padding: 10px 20px;
  text-decoration: none;
  border-radius: 5px;
  font-size: var(--font-size-body);
  font-family: var(--font-title);
  font-weight: bold;
  transition: background-color 0.3s;

  &:hover {
    background-color: var(--accent-color);
  }
`;

const DocumentList = styled.ul`
  list-style: none;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const DocumentItem = styled.li`
  font-size: var(--font-size-body);
  margin-bottom: 10px;

  a {
    color: var(--primary-color);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export default AllTheGoodStuff;
